module.exports = __webpack_public_path__ + "img/ClickForSound_36.b205242c.png";